import axios from 'axios'
import config from '@/config'

export default {
    
    getSalaryTableCount(branch, dep, position, search, fromDate,toDate) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/salaryplan/getSalaryTableCount`, {
            params: {
                'branch': branch,
                'dep': dep,
                'position': position,
                'search': search,
                'fromdate': fromDate,
                'todate': toDate,
                companyid: _company_guid,
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getSalaryTableLimit(branch, dep, position, search, fromDate,toDate,offset,limit) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/salaryplan/getSalaryTableLimit`, {
            params: {
                'branch': branch,
                'dep': dep,
                'position': position,
                'search': search,
                'fromdate': fromDate,
                'todate': toDate,
                companyid: _company_guid,
                offset:offset,
                limit:limit
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getSalaryTable(branch, dep, position, search, fromDate,toDate) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/salaryplan/getSalaryTable`, {
            params: {
                'branch': branch,
                'dep': dep,
                'position': position,
                'search': search,
                'fromdate': fromDate,
                'todate': toDate,
                companyid: _company_guid,
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getTimePlanTableCheckIn(branchCode,department,usercode,begin_date,end_date){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        let url = null;
        if(department=="All" ){
            department ='' 
        }  
        if(branchCode=="All"){
            branchCode ='' 
        }
         if (department == '' && usercode == '') {
          url = 'checkintable/' + begin_date + "/" + end_date + "/" + branchCode + "/" + usercode;
        } else if (department == '' && usercode != '') {
          url = 'checkintable/' + begin_date + "/" + end_date + "/" + branchCode + "/" + usercode;
        } else if (department != '' && usercode == '') {
          url = 'checkintable/dep/' + begin_date + "/" + end_date + "/" + branchCode + "/" + department;
        } else if (department != '' && usercode != '') {
          url = 'checkintable/' + begin_date + "/" + end_date + "/" + branchCode + "/" + department + "/" + usercode;
        } else {
          url = 'checkintable/' + begin_date + "/" + end_date + "/" + branchCode;
        }   
        return http.get(url, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    }
}